export enum AssignationType {
  STAFF_TEAM = 'team',
  STAFFING = 'staffing',
  PROJECT = 'project',
}
